module.exports = __webpack_public_path__ + "img/mfd_in_1_title.a0ef0a80.png";